/**
 * FeedbackPage — Port of feedback.page.html
 * Warm traditional theme + link to FAQ
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';

const T = {
  bgPage: '#f0f5e8', bgGreenPale: '#e8f5e9', bgCream: '#fffef0',
  textGreenDark: '#1b5e20', textGreenDeep: '#0d3b0f', textMaroon: '#6d1b1b',
  borderGreen: '#c8e6c9', gold: '#f0d48a',
  headerBg: 'linear-gradient(135deg, #090b72, #1a237e)',
};

const FeedbackPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('பஞ்சாங்கம் App Feedback from ' + name);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    window.open(`mailto:drnvs@outlook.com?subject=${subject}&body=${body}`);
    setSubmitted(true);
  };

  const inputStyle = {
    width: '100%', padding: '10px', borderRadius: '8px', border: `1px solid ${T.borderGreen}`,
    fontSize: '0.95rem', boxSizing: 'border-box', background: T.bgCream, color: T.textGreenDeep,
    outline: 'none', fontFamily: 'inherit'
  };

  return (
    <div style={{ padding: '10px', background: T.bgPage, minHeight: '80vh' }}>
      <div style={{ background: T.headerBg, padding: '14px', borderRadius: '12px', textAlign: 'center', marginBottom: '12px', borderBottom: '3px solid #ff9800' }}>
        <h1 style={{ color: 'white', fontSize: '1.15rem', margin: 0, fontWeight: 800 }}>📝 கருத்துக்கள்</h1>
        <p style={{ color: T.gold, fontSize: '0.85rem', margin: '4px 0 0' }}>Feedback / Suggestions</p>
      </div>

      {/* Link to FAQ */}
      <Link to="/faq" style={{
        display: 'block', padding: '10px', borderRadius: '10px', marginBottom: '12px',
        background: T.bgGreenPale, border: `1px solid ${T.borderGreen}`, textDecoration: 'none',
        textAlign: 'center', color: T.textGreenDark, fontWeight: 700, fontSize: '0.85rem'
      }}>
        📚 அடிக்கடி கேட்கும் கேள்விகள் (FAQ) பார்க்க இங்கு அழுத்துக →
      </Link>

      {submitted ? (
        <div style={{ backgroundColor: T.bgGreenPale, borderRadius: '12px', padding: '24px', textAlign: 'center', border: `1px solid ${T.borderGreen}` }}>
          <div style={{ fontSize: '3rem', marginBottom: '12px' }}>✅</div>
          <h2 style={{ color: T.textGreenDark }}>நன்றி!</h2>
          <p style={{ color: T.textGreenDeep }}>உங்கள் கருத்துகள் பெறப்பட்டன. நாங்கள் விரைவில் பதிலளிப்போம்.</p>
          <button onClick={() => setSubmitted(false)} style={{
            marginTop: '12px', padding: '8px 24px', background: T.headerBg,
            color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 700
          }}>மீண்டும் அனுப்ப</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ backgroundColor: T.bgCream, borderRadius: '12px', padding: '18px', border: `1px solid ${T.borderGreen}` }}>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ display: 'block', fontWeight: 700, marginBottom: '4px', color: T.textGreenDark }}>பெயர் (Name)</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ display: 'block', fontWeight: 700, marginBottom: '4px', color: T.textGreenDark }}>மின்னஞ்சல் (Email)</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={inputStyle} />
          </div>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ display: 'block', fontWeight: 700, marginBottom: '4px', color: T.textGreenDark }}>கருத்து (Message)</label>
            <textarea value={message} onChange={e => setMessage(e.target.value)} required rows={5}
              style={{ ...inputStyle, resize: 'vertical' }} />
          </div>
          <button type="submit" style={{
            width: '100%', padding: '12px', background: T.headerBg,
            color: 'white', border: 'none', borderRadius: '10px', fontSize: '1rem', fontWeight: 800, cursor: 'pointer'
          }}>📤 அனுப்பு (Send)</button>
        </form>
      )}
    </div>
  );
};
export default FeedbackPage;
